export default __webpack_public_path__ + "static/media/arrow-up.8813366f.svg";